module.exports = __webpack_public_path__ + "img/logo.e10ed6da.png";